import { ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule, RoutesRecognized } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faChevronLeft, faCircleCheck, faCircleExclamation, faDoorOpen, faRightFromBracket } from "@fortawesome/pro-light-svg-icons";
import { Dialog } from '@core/models/dialog.interface';
import { StoresService } from '@core/services/stores.service';
import Messages from '@core/utils/functions/messages.function';
import { LoginService } from 'src/app/pages/login/login.service';
import Loadding from '@core/utils/functions/loadding.function';
import { isSafariDesktop } from '@core/utils';



@Component({
  selector: 'app-flujo-layout',
  standalone: true,
  imports: [CommonModule, RouterModule, FontAwesomeModule],
  templateUrl: './flujo-layout.component.html',
  styleUrls: ['./flujo-layout.component.scss']
})
export class FlujoLayoutComponent implements OnInit {

  @ViewChild('main', { static: true }) main: ElementRef | undefined;
  @ViewChild('subAnimate', { static: true }) subAnimate: ElementRef | undefined;

  // icons
  faRightFromBracket = faRightFromBracket;

  urlAnimate!: boolean;
  animate!: boolean;

  constructor(private router: Router, private _messages: Messages, private _loading: Loadding, private stores: StoresService, private renderer: Renderer2, private LoginService: LoginService) { }

  ngOnInit(): void {

    this.stores.getAnimate().subscribe({
      next: (value) => {
        this.animate = value;

      }
    })

    const rutaValidator = this.router.url.includes('/dashboard');
    if (rutaValidator) {
      this.stores.startAnimate(true);
    } else {
      this.stores.startAnimate(false);
    }

    this.router.events.subscribe((data: any) => {
      if (data instanceof RoutesRecognized) {
        this.urlAnimate = data.url.includes('/dashboard')
        if (this.urlAnimate) {
          this.stores.startAnimate(true);
        } else {
          this.stores.startAnimate(false);
        }
      }
    });

  }

  ngAfterViewInit(): void {

    const rutaValidator = this.router.url.includes('/dashboard');
    if (rutaValidator) {
      this.renderer.setStyle(document.body, 'overflow', 'hidden');
      this.renderer.setStyle(this.main?.nativeElement, 'overflow', 'visible');
      // Escuchar el evento de finalización de la animación en el elemento referenciado por subAnimate
      this.subAnimate?.nativeElement.addEventListener('animationend', () => {
        // Cambiar overflow a auto una vez que termine la animación en el elemento main
        this.renderer.removeStyle(document.body, 'overflow');
        this.renderer.setStyle(this.main?.nativeElement, 'overflow', 'auto');
      });
    }

  }

  isSafari(): boolean {
    return isSafariDesktop()
  }


  logOut() {
    let data: Dialog = {
      icon: {
        name: faDoorOpen,
        container: 'bg-warning color-warning',
      },
      title: 'Are you sure you want to log out?',
      confirmButton: { text: 'Log Out', icon: faRightFromBracket },
      cancelButton: { text: 'Back', icon: faChevronLeft },
      padding: '3rem 1.3rem 1.5rem',
      data: {}
    };

    this._messages.showMessage(data).subscribe({
      next: (resp) => {
        if (resp) {
          localStorage.clear();
          sessionStorage.clear();
          this.router.navigate(['/login']);
        }
      }, error: (error) => {
        this._loading.setModalLoadingState(false);
      },
    });
  }

  home() {
    const typeUrl = this.router.url.split('/')[1];
    this.router.navigate([`/${typeUrl}/dashboard`]);
  }

}
